export const DD_AD_SDK_MANIFEST_LOADED = 'ad-sdk-manifest-loaded';

export const DD_UPLOAD_START = 'upload-start';

export const DD_UPLOAD_COMPLETED = 'upload-completed';

export const DD_UPLOAD_CANCELLED = 'upload-cancelled';

export const DD_UPLOAD_CREATED = 'upload-created';

export const DD_LOGIN_REQUIRED = 'login-required';

export const DD_USER_UNKNOWN = 'user-not-recognized';

export const DD_USER_SUBMIT_COUPON = 'user-submit-coupon';

export const DD_USER_ERROR_COUPON = 'user-submit-coupon-error';

export const DD_USER_SUCCESS_COUPON = 'user-submit-coupon-success';
